import { useWhyDidYouUpdate } from 'ahooks';

export default function useConditionalWhyDidYouUpdate(
  name: string,
  props: Record<string, unknown>,
  condition: boolean,
) {
  useWhyDidYouUpdate(name, condition ? props : {});
}
